export function RuoBanner() {
  return (
    <div className="bg-[#111216] text-white" data-testid="ruo-banner">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-[10.5px] sm:text-xs font-mono tracking-[0.2em] uppercase">
          <span className="inline-flex h-2 w-2 bg-[#F5A623]" />
          Research Use Only · Not for Human or Veterinary Consumption
        </div>
        <div className="hidden md:block text-[10.5px] font-mono tracking-[0.2em] uppercase text-white/60">
          Controlled Laboratory Use · Qualified Buyers Only
        </div>
      </div>
    </div>
  );
}
